import { c as _c } from "react/compiler-runtime";
import { getStatusMeta } from "../../../call/constants";
import React from "react";
import Badge from "@/components/ui/badge";
import { PlayAudio } from "@/components/ui/play-audio";
import { formatToHumanReadable } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
import { ToolCallSummary } from "@/types/call";
import { CallStatus } from "@/types/enums/call";
import { getAudioURL } from "@/api/provider/comms/call";
interface MessageCallProps {
  summary?: string | null;
  toolCalls?: ToolCallSummary[];
  audioPath?: string | null;
  callId: string;
  size?: "sm" | "lg";
  /** Drives the voicemail label; other statuses read fine from the summary. */
  status?: CallStatus;
}
function friendlyToolText(toolName: string): string {
  switch (toolName) {
    case "SendTextInvoice":
      return "Sent Text Invoice";
    case "SendEmailInvoice":
      return "Sent Email Invoice";
    case "SendPhysicalMailInvoice":
      return "Sent Mailed Invoice";
    case "NotifyBillingStaff":
      return "Notified Billing Staff of Request";
    default:
      return formatToHumanReadable(toolName);
  }
}
export function MessageCall(t0) {
  const $ = _c(18);
  const {
    summary,
    toolCalls,
    audioPath,
    callId,
    size: t1,
    status
  } = t0;
  const size = t1 === undefined ? "lg" : t1;
  const isVoicemail = status === CallStatus.VOICEMAIL;
  let t2;
  if ($[0] !== isVoicemail) {
    t2 = isVoicemail ? getStatusMeta(CallStatus.VOICEMAIL) : null;
    $[0] = isVoicemail;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const voicemailMeta = t2;
  let t3;
  if ($[2] !== voicemailMeta) {
    t3 = voicemailMeta && <div className="mb-1.5"><Badge variant={voicemailMeta.badgeVariant} size="xs" icon={voicemailMeta.icon}>{voicemailMeta.label}</Badge></div>;
    $[2] = voicemailMeta;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isVoicemail || $[5] !== size || $[6] !== summary) {
    t4 = summary ? <div className={size === "sm" ? "text-caption" : "text-body"}>{summary}</div> : isVoicemail && <div className={cx("text-foreground-secondary", size === "sm" ? "text-caption" : "text-body")}>Caller left a voicemail.</div>;
    $[4] = isVoicemail;
    $[5] = size;
    $[6] = summary;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== toolCalls) {
    t5 = toolCalls && toolCalls.length > 0 && <div className="mt-2"><span>Actions taken:</span><ul className="list-disc pl-4 font-medium">{toolCalls.map(_temp)}</ul></div>;
    $[8] = toolCalls;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== audioPath || $[11] !== callId) {
    t6 = audioPath && <div className="mt-2 w-full rounded-full bg-background-secondary px-2 py-1 [&_*]:!text-foreground"><PlayAudio audioPath={audioPath} id={callId} getAudioURL={getAudioURL} className="w-full items-start" /></div>;
    $[10] = audioPath;
    $[11] = callId;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <>{t3}{t4}{t5}{t6}</>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp(toolCall) {
  return <li key={toolCall.id}><span>{friendlyToolText(toolCall.toolName)}</span></li>;
}